import { Controller, type Control } from "react-hook-form";
import type { Person } from "../../../../utils/backend-types";
import { CustomFormFieldWrapper } from "../../../BuildingBlocks/Forms/MantineFormFields/CustomFormFieldWrapper/CustomFormFieldWrapper";
import { ParticipationFieldEditor } from "./ParticipationFieldEditor";

const PARTICIPATION_FIELD_LABEL =
  "Teilnahme am Mieterstrommodell - Soll mit Solarstrom beliefert werden.";

interface ParticipationFieldControllerProps {
  control: Control<Person>;
  isMissing?: boolean;
  name: "participationsInMieterstromModel";
}

/**
 * React Hook Form controller for participation field integration.
 * Handles data conversion between Array<Participation> and the internal component state.
 */
function ParticipationFieldController({
  control,
  isMissing,
  name
}: ParticipationFieldControllerProps) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <CustomFormFieldWrapper
          highlight={isMissing && !value?.length}
          label={PARTICIPATION_FIELD_LABEL}
          name={name}
        >
          <ParticipationFieldEditor
            participations={value}
            onChange={onChange}
          />
        </CustomFormFieldWrapper>
      )}
    />
  );
}

export { ParticipationFieldController };
